'use client'
import React from 'react'
import dynamic from 'next/dynamic'

import processSteps from '../../_utilities/data/sections/process-step.json'
import HeroSlideshowSlider from '../Sliders/HeroSlideshow'
const DigitalService = dynamic(() => import('../Section/DigitalServices'), { ssr: false })
const ProcessSection = dynamic(() => import('../Section/ProcessSection'), { ssr: false })
const Technology = dynamic(() => import('../Sliders/Technology'), { ssr: false })
const IndustriesSection = dynamic(() => import('../Section/IndustriesSection'), { ssr: false })
const CounterSection = dynamic(() => import('../Section/Award'), { ssr: false })
const ContactSection = dynamic(() => import('../Section/Contact'), { ssr: false })

const Home = () => {
  return (
    <div>
      {/* Homepage section*/}
      <HeroSlideshowSlider />

      {/* digital services section*/}
      <DigitalService />

      {/* Developer section*/}
      <section className="mil-deep-bg mil-p-40-0">
        <div className="container">
          <div className="row ">
            <div className="col-xl-7">
              <h2 className="mil-mb-10 mil-h2">
                Our Development <span className="mil-accent">Process</span>
              </h2>
              <p className="mil-mb-30  mil-dig-text">
                We strictly follow Software Development Life Cycle in Our All Projects
              </p>
            </div>
          </div>
          <ProcessSection steps={processSteps} />
        </div>
      </section>

      {/* technology section*/}
      <section className="mil-p-40-0">
        <div className="container">
          <div className=" mil-mb-40  text-justify">
          <h2 className="mil-mb-10 mil-h2">
                Our Technology <span className="mil-accent">Stack</span> 
              </h2>
            <p className="mil-mb-30  mil-dig-text" style={{ textAlign: 'justify' }}> Take a transformative trip through the technical fabric of our time, where mastery and innovation meet. We confidently negotiate the complexities of React Native, Android, iOS, Java, Swift, Kotlin, Node.js, React.js, CSS, HTML, JavaScript, PHP, WordPress, MySQL, MongoDB, GitLab, Sublime Text, and beyond as trailblazers in the IT industry. Our team skillfully combines the artistic elements of UI/UX design with programming to create digital experiences that surpass users' expectations. Come along as we redefine the boundaries of technological possibility at the nexus of creativity and functionality.
            </p>
          </div>
        </div>
      </section>

      <Technology />

      {/* Industries section*/}
      <section className="mil-p-40-0" style={{paddingBottom:"20px"}}>
        <div className="container">
          <div className="mil-text-center">
            <h2 className="mil-h2">
              <span className="mil-accent">Industries We Serve</span>
            </h2>
          </div>
        </div>
      </section>

      <IndustriesSection />
      {/* Serving section */}

      <CounterSection />
      {/* contact section */}
      <ContactSection />
    </div>
  )
}

export default Home
